function findLessonByID(id, lessons) {
	for (const s in lessons) {
		if ((lessons[s].data.id && lessons[s].data.id === id) || (lessons[s].data.entityUID && lessons[s].data.entityUID === id)) {
			return lessons[s]
		}
	}
	return null
}

export default findLessonByID
